import React from 'react';
import { motion } from 'framer-motion';
import { Cpu, Database, Video, Brush, Globe, FileText, Quote } from 'lucide-react';

const Home = () => {

  const testimonials = [
    {
      name: "Sara Hajimohammadi",
      role: "Personal trainer and pilates instructor massage therapist",
      text: "Beta Pixel Studio made a professional site for me he delivered it on time and asked me what to do every time he wants to do changes i am totally happy with his work and recommend him to anyone who want to create websites",
      rating: 5
    },
    {
      name: "Alice Shapiro",
      role: "MId-Emerging Digital Artist",
      text: "Beta Pixel Studio created a high quality video, and was very helpful throughout the entire process, completing the work very quickly. Amazing work for a very good price. I highly recommended this Seller and am hiring again for a monthly project during 2023",
      rating: 5
    },
    {
      name: "Trista Suke",
      role: "Film Director, Writer & Social Media Strategist",
      text: "Beta Pixel Studio does great work. He was very responsive and worked hard to get my order right. I'd recommend him to anyone!",
      rating: 5
    },
    {
      name: "Konstantin Zavoronkov",
      role: "Sodeira Solutions OU",
      text: "Beta Pixel Studio worked back and forth to get the project done! Def a 5 star! Thanks again for your help.",
      rating: 5
    },
    
  ];

  return (
    <div className="sm:mt-8  md:pt-6 lg:pt-8 pt-10">
    <div className="min-h-screen flex flex-col justify-center items-center text-center relative overflow-hidden ">
      {/* Glitch Background Effect */}
      <br></br>
      <br></br>

      <div className="absolute inset-0 bg-gradient-to-br from-gray-900 via-black to-gray-800 opacity-50 animate-pulse"></div>

      <motion.div 
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7 }}
        className="relative z-10 max-w-4xl mx-auto px-4"
      >
        <h1 className="text-5xl md:text-7xl font-bold mb-6 text-transparent bg-clip-text bg-gradient-to-r from-purple-500 to-cyan-500">
          Beta Pixel Studio
        </h1>
        
        <p className="text-xl md:text-2xl text-gray-300 mb-10 tracking-wide">
          Transforming Digital Visions into Pixel-Perfect Realities
        </p>
        
        <div className="grid grid-cols-2 md:grid-cols-3 gap-6 mb-12">
          {[ 
            { icon: Brush, text: 'Graphics Design' },
            { icon: Video, text: 'Video Editing' },
            { icon: Globe, text: 'Web Development' },
            { icon: Database, text: 'Data Entry' },
            { icon: Cpu, text: 'WordPress Solutions' },
            { icon: FileText, text: 'Digital Services' }
          ].map((service, index) => (
            <motion.div
              key={index}
              whileHover={{ scale: 1.05 }}
              className="bg-gray-800/50 backdrop-blur-sm p-4 rounded-xl border border-purple-500/30 hover:border-cyan-500/50 transition-all"
            >
              <service.icon className="mx-auto mb-2 text-cyan-500" size={40} />
              <p className="text-sm text-gray-300">{service.text}</p>
            </motion.div>
          ))}
        </div>
        
        {/* <motion.button
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.9 }}
          className="bg-gradient-to-r from-purple-600 to-cyan-500 text-white px-8 py-3 rounded-full text-lg font-semibold hover:shadow-xl hover:shadow-purple-500/30 transition-all"
        >
          Why we choose us
        </motion.button> */}
      </motion.div>

      {/* Testimonials Section */}
      <div className="w-full py-16 px-4 bg-gray-900/50 backdrop-blur-sm mt-16">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold mb-12 text-transparent bg-clip-text bg-gradient-to-r from-purple-500 to-cyan-500 text-center">
            What Our Clients Say
          </h2>

          <div className="grid md:grid-cols-3 gap-8">
            {testimonials.map((testimonial, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, scale: 0.9 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ delay: index * 0.2 }}
                className="bg-gray-800/60 p-6 rounded-xl border border-purple-500/30 hover:border-cyan-500/50 transition-all"
              >
                <Quote className="text-cyan-500 mb-4" size={40} />
                <p className="text-gray-300 mb-4 italic">"{testimonial.text}"</p>
                <div className="flex items-center">
                  <div className="mr-4">
                    <h3 className="font-semibold text-white">{testimonial.name}</h3>
                    <p className="text-sm text-gray-400">{testimonial.role}</p>
                  </div>
                  <div className="flex ml-auto">
                    {[...Array(testimonial.rating)].map((_, i) => (
                      <span key={i} className="text-yellow-500 text-xl">★</span>
                    ))}
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>

      {/* Why Choose Us Section */}
      <div className="w-full py-16 px-4 bg-gray-900/50 backdrop-blur-sm mt-16">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold mb-12 text-transparent bg-clip-text bg-gradient-to-r from-purple-500 to-cyan-500 text-center">
            Why Choose Us
          </h2>

          <div className="grid md:grid-cols-2 gap-8">
            <motion.div
              initial={{ opacity: 0, y: 50 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
              className="bg-gray-800/60 p-6 rounded-xl border border-purple-500/30 hover:border-cyan-500/50 transition-all"
            >
              <h3 className="text-2xl font-bold text-white mb-4">Affordable Rates</h3>
              <p className="text-gray-300">
                We provide top-notch services at competitive prices, ensuring value for your investment.
              </p>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 50 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
              className="bg-gray-800/60 p-6 rounded-xl border border-purple-500/30 hover:border-cyan-500/50 transition-all"
            >
              <h3 className="text-2xl font-bold text-white mb-4">Ultimate Revision</h3>
              <p className="text-gray-300">
                We ensure that your vision is realized with unlimited revisions until you're fully satisfied.
              </p>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 50 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
              className="bg-gray-800/60 p-6 rounded-xl border border-purple-500/30 hover:border-cyan-500/50 transition-all"
            >
              <h3 className="text-2xl font-bold text-white mb-4">Long-term Relationships</h3>
              <p className="text-gray-300">
                Building lasting relationships with our clients through trust and exceptional service.
              </p>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 50 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
              className="bg-gray-800/60 p-6 rounded-xl border border-purple-500/30 hover:border-cyan-500/50 transition-all"
            >
              <h3 className="text-2xl font-bold text-white mb-4">Quality Work</h3>
              <p className="text-gray-300">
                Delivering high-quality work that exceeds expectations and ensures your satisfaction.
              </p>
            </motion.div>
          </div>
        </div>
      </div>
    </div>
    </div>
  );
};

export default Home;
